import Vue from 'vue'

# Polyfills that aren't provided by polyfill.io.  I'm not using core-js from
# Babel so I don't double up on polyfills.
import 'regenerator-runtime'
import 'objectFitPolyfill'

# Add Sentry error logging
import '../plugins/sentry'

# JS with side-effects to apply globally
import 'focus-visible'

# Global styles
import 'normalize.css'
import '../styles/app.styl'

# Modernizr, which should possibly moved into the html if this is an issue
import 'library/vendor/modernizr.min'

# VueX
import '../plugins/vuex'

# Install global helpers
import * as helpers from 'library/services/helpers'
Vue.prototype['$' + key] = func for key, func of helpers
Vue.filter 'money', helpers.formatMoney
Vue.prototype.$cartEnabled = process.env.CART_ENABLED
helpers.addInittedClass()
import '../plugins/craft'
import '../plugins/gtm'

# Inject constants
import { GTM_EVENTS, GTM_COMPONENTS } from 'library/constants'
Vue.prototype.$GTM_EVENTS = GTM_EVENTS
Vue.prototype.$GTM_COMPONENTS = GTM_COMPONENTS

# Add I18n to Vue
Vue.prototype.$i18n = defaultLocale: 'en_US'

# Share Storefront API globally. This allows usage in library components that
# get built on Nuxt and don't need to load Storefront client like would happen
# via import.
import * as storefront from 'library/services/shopify/storefront'
Vue.prototype.$storefront = storefront

# Capture web vitals with foo
import { captureWebVitals } from 'library/services/foo'
captureWebVitals()

# Helper function that strips the render function from a component so a normal
# single-file-component with a template block can be used as the component for
# an inline-component.
stripRender = (component) ->
	clone = { ...component }
	delete clone.render
	return clone

# Add shared global components
import balanceText from 'vue-balance-text'
Vue.directive 'balance-text', balanceText
import unorphan from 'vue-unorphan'
Vue.directive 'unorphan', unorphan

# Vue Visual
import Visual from 'vue-visual'
import CraftVisual from 'library/components/global/visual/craft-visual'
import ShopifyVisual from 'library/components/global/visual/shopify-visual'
import ResponsiveVisual from 'library/components/global/visual/responsive-visual'
Vue.component 'visual', Visual
Vue.component 'craft-visual', CraftVisual
Vue.component 'shopify-visual', ShopifyVisual
Vue.component 'responsive-visual', ResponsiveVisual
import 'vue-visual/index.css'

# Layout components
import FullCart from '../components/cart/full-cart'
import CartIcon from 'library/components/layout/cart-icon'
import LayoutFooter from '../components/layout/layout-footer'
import LayoutHeader from '../components/layout/layout-header'
Vue.component 'full-cart', FullCart
Vue.component 'cart-icon', CartIcon
Vue.component 'layout-footer', LayoutFooter
Vue.component 'layout-header', LayoutHeader

# Global Components
import Btn from 'library/components/global/buttons/btn'
import Placeholder from 'library/components/global/placeholder'
import Spacer from 'library/components/global/spacer'
Vue.component 'btn', Btn
Vue.component 'placeholder', Placeholder
Vue.component 'spacer', Spacer

# Stub out the parse-anchors directive so it doesn't fatal error
Vue.directive 'parse-anchors', {}

# A non-Nuxt implementation of client-only component
import ClientOnly from 'vue-client-only'
Vue.component 'client-only', ClientOnly

# Make smart-link instance switch domains
import { makeAnchor } from 'library/components/global/smart-link'
import { isNuxtUrl, makeNuxtUrl } from 'library/services/helpers'
Vue.component 'smart-link',
	functional: true
	props: to: String
	render: (create, context) ->
		to = context.props.to
		if !to then return create 'span', context.data, context.children
		if isNuxtUrl to
		then makeAnchor create, context, makeNuxtUrl to
		else makeAnchor create, context

# Setup ignored elements for Ordergroove components
Vue.config.ignoredElements = [
	/og-*/
]

# Forward on to checkout after a customer signs in while attempting to
# purchase a subscription.
import { returnToSubscriptionCheckout } from '../components/account/subscriptions-require-account-notice'
returnToSubscriptionCheckout()

# Capture SFMC query params
import { captureSfmcQueryParams } from 'library/services/sfmc/conversion'
captureSfmcQueryParams helpers.currentQueryParams()

# Create redirects to www. This is done from here rather than in inline styles
# so other code can act first, such as booting vuex
if window.TEMPLATE_NAME in ['404', 'search', 'index']
	path = if location.search.match /www\-redirect/
	then '/404' else location.pathname
	location.href = makeNuxtUrl path

# Fire Page Mounted at the end. This must be after the share-customer plugin
# is executed.
import { firePageView } from 'library/services/gtm/page-view'
firePageView
	$gtm: Vue.prototype.$gtm
	$store: window.$store

# Fake the Vuetify config to fix a-la-carte support
Vue.prototype.$vuetify =
	rtl: false
	theme: disable: true
	icons: iconfont: 'icomoon'

# Share Axios globally
import axios from '../../node_modules/axios'
Vue.prototype.$axios = axios

# Load recaptcha on interactions
import { initRecaptchaListener } from 'library/services/load-recaptcha'
initRecaptchaListener()

# Sync OneTrust consent choices to Shopify Privacy
import { syncOneTrustToShopifyPrivacy } from '../plugins/privacy'
syncOneTrustToShopifyPrivacy()

# Export the method that will initialize Vue instances
import { initTranslations } from '../plugins/i18n'
export initVue = () ->

	# Load translations which are needed before Vue components mount because
	# template variables need simple primitives
	await initTranslations()

	# Get a list of all current components in the dom via data-attribute
	components = document.querySelectorAll '[inline-template],
		[data-vue-component]'

	# Create new vue instances for each element to be mounted but not for
	# inline-templates within another inline-template.
	components.forEach ( el ) ->
		return if el.matches '[inline-template] [inline-template]'

		# Make a name for the Vue instance for Vue dev tools
		name = el.getAttribute('data-vue-component') ||
			el.getAttribute('is') || el.tagName

		# Instantiate the Vue instance
		window["$#{name}"] = new Vue {
			name
			store: window.$store
			delimiters: ['${', '}']
			el
			router: window.$router
		}

	# Report JS ready
	window.VUE_INITTED = true
